// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import routeProps from './routeProps';

if (process.env.NODE_ENV === 'development') {
  Object.entries(routeProps).forEach(([key, value]) => {
    const internalProps = ['path', 'id', 'parentId', 'isLayout', 'isWrapper', 'layout', 'clientLoader'];
    Object.keys(value).forEach((prop) => {
      if (internalProps.includes(prop)) {
        throw new Error(
          `[UmiJS] route '${key}' should not have '${prop}' prop, please remove this property in 'routeProps'.`
        )
      }
    })
  })
}

import React from 'react';

export async function getRoutes() {
  const routes = {"404":{"path":"*","id":"404","parentId":"@@/global-layout"},"order/pay/success/$number":{"path":"order/pay/success/:number","id":"order/pay/success/$number","parentId":"@@/global-layout"},"order/pay/$orderNumber":{"path":"order/pay/:orderNumber","id":"order/pay/$orderNumber","parentId":"@@/global-layout"},"order/read/$id":{"path":"order/read/:id","id":"order/read/$id","parentId":"@@/global-layout"},"order/create":{"path":"order/create","id":"order/create","parentId":"@@/global-layout"},"order/list":{"path":"order/list","id":"order/list","parentId":"@@/global-layout"},"index":{"path":"/","id":"index","parentId":"@@/global-layout"},"@@/global-layout":{"id":"@@/global-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'404': React.lazy(() => import(/* webpackChunkName: "src__pages__404" */'../../../src/pages/404.tsx')),
'order/pay/success/$number': React.lazy(() => import(/* webpackChunkName: "src__pages__order__pay__success__$number" */'../../../src/pages/order/pay/success/$number.tsx')),
'order/pay/$orderNumber': React.lazy(() => import(/* webpackChunkName: "src__pages__order__pay__$orderNumber" */'../../../src/pages/order/pay/$orderNumber.tsx')),
'order/read/$id': React.lazy(() => import(/* webpackChunkName: "src__pages__order__read__$id" */'../../../src/pages/order/read/$id.tsx')),
'order/create': React.lazy(() => import(/* webpackChunkName: "src__pages__order__create" */'../../../src/pages/order/create.tsx')),
'order/list': React.lazy(() => import(/* webpackChunkName: "src__pages__order__list" */'../../../src/pages/order/list.tsx')),
'index': React.lazy(() => import(/* webpackChunkName: "src__pages__index" */'../../../src/pages/index.tsx')),
'@@/global-layout': React.lazy(() => import(/* webpackChunkName: "layouts__index" */'E:/project/hcsw-apply-pay/hcsw-mass-pay/src/layouts/index.tsx')),
},
  };
}
